import React, {useEffect, useState} from 'react';
import Loader from 'react-loader';
import Layouts from '../../components/layouts/Layouts';
import Toolbar from '../../components/headers/home/Toolbar';
import _ from 'lodash';
import { fetchMatchData } from '../../actions/matchDataActions';
import { useHistory } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

const LaunchAppPage = props => {
    const access = props.connexionReducer;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const randomMessage = [
        'Chargement du calendrier en cours...', 
        'Chargement des favoris...', 
        'Chargement des lives...'
    ];
    const [message, setMessage] = useState(randomMessage[0]);
    const history = useHistory();

    useEffect(() => {
        const interval = setInterval(() => {
            const index = _.random(0, randomMessage.length - 1);
            setMessage(randomMessage[index]);
        }, 300);

        if(access) {
            props.fetchMatchData(access).then(() => history.push('/matches'))
        }

        return () => clearInterval(interval);
    }, [access, history, props, randomMessage]);

    const settings = [
        {
            key: 'edit',
            to: '/profile/settings',
            name: 'Modifier le profil'
        },
        {
            key: 'demo',
            to: '/live/demo',
            name: 'Démo'
        }
    ];
    
    return (
        <Layouts
            toolbar={() => <Toolbar close settings={settings} title='Live Score' />}
        >
            <Loader 
                loaded={false} lines={13} length={20} width={10} radius={30}
                corners={1} rotate={0} direction={1} color="#004586" speed={1}
                trail={60} shadow={false} hwaccel={false} className="spinner"
                zIndex={2e9} top="35%" left="52%" scale={0.3}
                loadedClassName="loadedContent" 
            />
            <div style={styles.message}>{message}</div>
        </Layouts>
    )
}

const styles = {
    message: {
        position: 'absolute',
        top: '45%',
        left: '23%',
        fontFamily: 'fff-equipe',
        color: '#004586',
        fontWeight: 700
    }
}

const mapStateToProps = ({connexionReducer}) => ({connexionReducer});

const mapDispatchToProps = dispatch => bindActionCreators({fetchMatchData}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(LaunchAppPage);